module.exports = __webpack_public_path__ + "img/汽车展厅亮暗.3daef045.png";